<script>
import { mapActions } from 'vuex';
import LogoHeader from '../components/onboarding/logo-header.vue';

export default {
  name: 'TrialSuccess',
  components: {
    LogoHeader,
  },
  data() {
    return {
      currentPhraseIndex: 0,
      intervalId: null,
      fadeIn: true,
      phrases: [
        'Loading your roulette settings...',
        'Setting up your roulette...',
        'Setting up your preferences...',
        'Finalizing your account setup...',
        'Almost there...',
        'Your roulette is ready!',
      ],
    };
  },
  watch: {
    currentPhraseIndex(newIndex) {
      if (newIndex === this.phrases.length - 1) {
        clearInterval(this.intervalId);
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    },
  },
  created() {
    this.updateOnboardingStep('complete');
  },
  mounted() {
    this.intervalId = setInterval(this.rotatePhrase, 2000);
  },
  unmounted() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions(['updateOnboardingStep']),
    rotatePhrase() {
      this.fadeIn = false;
      setTimeout(() => {
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
        this.fadeIn = true;
      }, 500);
    },
  },
};
</script>

<template>
  <div id="main-container" class="container-fluid">
    <div class="row">
      <div class="logo-container">
        <logo-header />
      </div>
    </div>
    <div class="text-center">
      <div class="my-5">
        <b-spinner variant="primary" style="width: 4rem; height: 4rem" />
      </div>
      <div class="h-20 d-flex align-items-center justify-content-center my-5">
        <h3 class="my-4 text-center w-100" :class="{ 'fade-in': fadeIn }">
          {{ phrases[currentPhraseIndex] }}
        </h3>
      </div>
      <div class="mt-5">
        <span
          v-for="(_, index) in phrases"
          :key="index"
          class="d-inline-block rounded-circle mx-2 indicator"
          :class="{ active: index === currentPhraseIndex }"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#main-container {
  height: 100vh;
  width: 100%;
  background-color: #f4f7fc;
}
.logo-container {
  padding: 70px;
}

.light-blue {
  background-color: #f4f7fc;
}

.fade-in {
  opacity: 1;
  transition: opacity 0.5s;
}

h3 {
  opacity: 0;
  transition: opacity 0.5s;
}

.indicator {
  width: 16px;
  height: 16px;
  transition: background-color 0.3s;
  background-color: lightgrey;
}

.indicator.active {
  background-color: #ff5f42;
}
</style>
